// export const refreshIntervalForUserNotifications: number = 200000;
export const refreshIntervalForUserNotifications: number = 60000;
